import { WHATS_NEXT_APIS } from "features/Onboarding/modules/WhatsNext/WhatsNext.api";

export const GET_CONTACTS_LIST = "host/crm/inbox";
export const GET_INBOX_LEADS_LIST = "host/inbox/lead/search";
export const MARK_INBOX_READ = "host/crm/inbox/read";
export const GET_INBOX_NOTIFICATIONS_COUNT = WHATS_NEXT_APIS.GET_PROGRESS;
